import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DashboardService } from '@v3/dashboard/dashboard.service';

@Component({
    selector: 'ms-dashboard-sidebar-nav-item',
    templateUrl: './dashboard-sidebar-nav-item.component.html',
    styleUrls: ['./dashboard-sidebar-nav-item.component.scss'],
    standalone: false
})
export class DashboardSidebarNavItemComponent implements AfterViewInit {
  @Input() link: string;

  @Input() href: string;

  @Input() target: '_blank' | null = null;

  @Input() iconClass: string;

  @Input() exactMatch: boolean = false;

  @Input() color: 'purple' | 'yellow' = 'purple';

  @ViewChild('contentWrapper') content: ElementRef<HTMLElement>;

  /**
   * Текст пункта меню из проецируемого содержимого (ng-content).
   * Вычисляется один раз в ngAfterViewInit, когда ViewChild уже доступен.
   * Раньше вычислялся в геттере tooltip, который читал this.content до его
   * инициализации — значение менялось между проверками CD (undefined → текст),
   * что вызывало NG0100 ExpressionChangedAfterItHasBeenCheckedError.
   */
  private _projectedText = '';

  get isShrink() {
    return this._dashboardService.isShrink;
  }

  get tooltip() {
    return (this.isShrink || window.innerWidth <= 1024) ? this._projectedText : '';
  }

  constructor(
    private readonly _dashboardService: DashboardService,
  ) {}

  ngAfterViewInit(): void {
    // ViewChild доступен здесь — читаем проецируемый текст один раз
    this._projectedText = this.content?.nativeElement.textContent ?? '';
  }

  protected redirectToHref(href: string): void {
    if (href) {
      window.open(href, '_blank');
    }
  }
}
